<template>
  <div
    class="add-melody-record-container"
    :class="{
      [`add-melody-record-container--${createRenderType}`]: true,
      [`add-melody-record-container--cn`]: globalConfig.appname == chinaAppName,
    }"
  >
    <div class="add-melody-record-main" @click="doAddReferenceRecord">
      <div class="add-melody-new-corner-mark" v-if="vocalCornerMarkVisible">
        <span class="block">{{ $$t("common.new") }}</span>
      </div>
      <div
        class="add-melody-record pointer"
        :class="{
          [`add-melody-record--${createRenderType}`]: true,
        }"
      >
        <i class="block"></i>
        <span class="block">{{ $$t("create.record_singing") }}</span>
        <label class="vip_plan" v-if="userDataStore.userInfo?.user?.vip_level_name != 'pro'">
          {{ $$t("create.pro_plan") }}
        </label>
      </div>
      <div class="add-melody-record-desc">
        {{ $$t("create.add_melody_record_desc") }}
      </div>

      <div
        class="add-music-reference-edit-mask pointer"
        @click="
          (e) => {
            showSubscribeDialog()
            // goSubscribe(2, 'motif_record');
          }
        "
        v-if="userDataStore.userInfo?.user?.vip_level_name != 'pro'"
      ></div>
    </div>

    <AddRecordDialog
      v-model:visible="renderData.addLinkDialogVisible"
      v-if="renderData.addLinkDialogVisible"
      @handleRecordCompleted="doAddReferenceRecordDone"
    />
    <EditRecordClip
      v-model:visible="renderData.editFilePopupVisible"
      v-if="renderData.editFilePopupVisible"
      :clipSourceData="renderData.clipSourceData"
      @complete="handleEditFileCompleted"
    >
    </EditRecordClip>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
  getCurrentInstance,
} from "vue"

import { useRouter, useRoute } from "vue-router"
import globalConfig, {
  chinaAppName,
  ModuleOpenStateControl,
  getPipeReadableFlowUrl,
} from "@/config/config.js"

import AddRecordDialog from "./addRecordEdit.vue"
import EditRecordClip from "./editRecordClip.vue"

import { $$language, $$t } from "@/i18n/i18n.js"
import tools from "@/utils/tools.js"

import apiReferMusic from "@/api/api/apiReferMusic.js"
import userReferMusicStore from "@/store/create/motifDataStore.js"

import ffmpegUtil from "@/components/media/utils/ffmpegUtil.js"
import message from "@/components/functionCallComponent/message.jsx"
import clipUtil from "@/components/media/utils/clipUtil.js"
import objectStorage, {
  getObjectStorageFullUrl,
} from "@/lib/objectStorage/objectStorage.js"
import axios from "axios"
import { storeToRefs } from "pinia"
import useCreateLayoutStore from "@/store/create/createLayoutStore.js"
import useUserDataStore from "@/store/userDataStore.js"
const createLayoutStore = useCreateLayoutStore()
const userDataStore = useUserDataStore()
const { createRenderType, vocalCornerMarkVisible } =
  storeToRefs(createLayoutStore)
const Router = (getCurrentInstance() || (window?.$getVueCurrentInstance?.())).appContext?.config?.globalProperties?.$router
const route = useRoute()

const appContext = (getCurrentInstance() || (window?.$getVueCurrentInstance?.())).appContext

const props = defineProps({})
const emits = defineEmits([])
const renderData = reactive({
  addLinkDialogVisible: false,
  file: null,
  editFilePopupVisible: false,
  clipSourceData: null,
})

const goSubscribe = async (e, membership_source2) => {
  e ?? window.event?.stopPropagation()
  if (await userDataStore.checkLoginStatus()) {
    Router.push({
      name: "subscribe",
      query: {
        membership_source1: "membership_feature",
        membership_source2,
      },
    })
  }
}

const showSubscribeDialog = () => {
  emits("showSubscribeDialog", "reference", {
    membership_source1: "membership_feature",
    membership_source2: "motif_recording",
  })
}

const doAddReferenceRecord = () => {
  renderData.addLinkDialogVisible = true
  appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.pause(
    appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.currentUrl
  )
}

const doAddReferenceRecordDone = (recoderData) => {
  doInitEditFile(recoderData.file, true)
  // renderData.file=  recoderData.file;
  // renderData.duration = recoderData.duration;
  // saveRecordFile(renderData.file);
}

const doDownloadFile = async (url, filename) => {
  return new Promise((resolve, reject) => {
    var xhr = new XMLHttpRequest()
    xhr.open("GET", url, true)
    xhr.responseType = "blob"
    xhr.onload = function (e) {
      if (this.status === 200) {
        var blob = new Blob([this.response], {
          type: this.response?.type || "text/plain",
        })
        const resfile = new File([blob], filename, { type: blob.type })
        resolve(resfile)
      } else {
        reject(this.statusText)
      }
    }
    xhr.send()
  })
}

const doInitEditFile = async (filep) => {
  let file = renderData.file ?? filep
  console.log("doInitEditFile", file.type, file)
  window.curSelectFile = file
  const closeMsg = message.loading({
    content: $$t("create.extract_song"),
  })
  let decodeData = null
  let blobUrl = null
  let duration = 0
  try {
    decodeData = await clipUtil.getDecodeDataByFile(file)
    duration = decodeData.duration
    blobUrl = (window.URL || window.webkitURL).createObjectURL(file)
  } catch (e) {
    try {
      console.log("name:", file.name, "type:", file.type, "size:", file.size)
      const outputfile = await ffmpegUtil.transFileToMp3(file)
      file = outputfile.file
      blobUrl = outputfile.blobUrl
      decodeData = await clipUtil.getDecodeDataByFile(file)
      duration = decodeData.duration
    } catch (e) {
      console.error("handleAfterReaderr", e)
      closeMsg.clear()
      message.info({
        content: $$t("create.extract_song_failed"),
      })
      return
    }
  }
  renderData.fileTemp = file

  console.log("renderEditFile", renderData.clipSourceData)
  closeMsg.clear()
  renderData.editFilePopupVisible = true
  nextTick().then(() => {
    renderData.clipSourceData = {
      duration: duration,
      isUpload: true,
      blobUrl: blobUrl,
      type: "audio/wav",
      decodeData,
    }
  })
}
const handleEditFileCompleted = async (fileData, close) => {
  const { getClipedExportData, data } = fileData
  const closeMsg = message.loading({
    position: "center",
    content: $$t("create.saving"),
  })
  let saveData = null
  try {
    let clipedExportData = await getClipedExportData()
    if (clipedExportData.blob.type != "audio/mp3") {
      try {
        let transfile = await ffmpegUtil.transFileToMp3(
          new File([clipedExportData.blob], "output.wav", { type: "audio/wav" })
        )
        clipedExportData.url = transfile.blobUrl
        clipedExportData.blob = transfile.blob
        clipedExportData.file = transfile.file
      } catch (e) {
        console.error("transFileToMp3 error", e)
      }
    }
    const fileSaveData = {
      url: clipedExportData.url,
      filename: data.filename,
      duration: clipedExportData.duration,
    }

    const objectStorageRes = await objectStorage.uploadFileToObjectStorage(
      clipedExportData.file,
      (obj) => {
        renderData.uploadCallbackData = obj
      }
    )
    saveData = {
      url: objectStorageRes.pathKey,
      duration_milliseconds: Math.ceil(fileSaveData.duration * 1000),
      upload_link: null,
      // feed_id: draftDataStore.feed_id,
      title: fileSaveData.filename,
      source_type: 4,
      resource: null,
    }
  } catch (e) {
    closeMsg.clear()
    console.error("uploadFileToObjectStorage error", e)
    message.error({
      position: "top",
      content: $$t("create.save_failed"),
    })
    return
  }

  saveMotif(saveData, close)
}

const saveRecordFile = async (file) => {
  const closeMsg = message.loading({
    position: "center",
    content: $$t("create.saving"),
  })
  let saveData = {}
  const fileSaveData = {
    filename: file.name.replace(/.[0-9a-zA-Z]+$/, ""),
  }
  try {
    if (file.type != "audio/mp3") {
      try {
        let transfile = await ffmpegUtil.transFileToMp3(file)
        fileSaveData.url = transfile.blobUrl
        fileSaveData.blob = transfile.blob
        fileSaveData.file = transfile.file
      } catch (e) {
        console.error("transFileToMp3 error", e)
      }
    }

    const objectStorageRes = await objectStorage.uploadFileToObjectStorage(
      fileSaveData.file,
      (obj) => {
        renderData.uploadCallbackData = obj
      }
    )
    saveData = {
      url: objectStorageRes.pathKey,
      duration_milliseconds: Math.ceil(renderData.duration * 1000),
      // feed_id: draftDataStore.feed_id,
      source_type: 4,
      title: fileSaveData.filename,
      bpm: 0,
    }
  } catch (e) {
    closeMsg.clear()
    console.error("uploadFileToObjectStorage error", e)
    message.error({
      position: "top",
      content: $$t("create.save_failed"),
    })
    return
  }
  saveMotif(saveData, close)
}

const saveMotif = async (saveData, close) => {
  const closeMsg = message.loading({
    position: "center",
    content: $$t("create.saving"),
  })

  apiReferMusic
    .addMotifMusic(saveData)
    .then((res) => {
      closeMsg?.clear()
      if (res.code == 200 && res.data) {
        renderData.file = null
        renderData.addLinkDialogVisible = false
        emits("saveSuccess", res.data)
        close?.()
      } else {
        if (res.code == 6308) {
          message.error({
            position: "top",
            content: $$t("create.motif_min_time_tip"),
          })
          close?.()
        } else if (res.code == 6353) {
          message.info({
            position: "top",
            content: $$t("create.generate_motif_audit_failed"),
          })
        } else if (res.code == 6320) {
          message.error({
            position: "top",
            content: $$t("create.song_cover_auditing_failed"),
          })
        } else if (res.code == 6316) {
          message.error({
            position: "top",
            content: $$t("create.song_title_audit_failed"),
          })
        } else {
          message.error({
            position: "top",
            content: $$t("create.save_failed"),
          })
        }
      }
    })
    .catch((err) => {
      closeMsg?.clear()
      console.error("addReferenceMusic error", err)
      message.error({
        position: "top",
        content: $$t("create.save_failed"),
      })
    })
}

onMounted(() => {})
</script>
<style lang="scss">
.add-melody-record-container {
  .add-melody-record-main {
    position: relative;
    height: 86px;
    border-radius: 12px;
    padding: 0 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: rgba(148, 173, 255, 0.1);
    position: relative;
    &:hover {
      background: rgba(148, 173, 255, 0.2);
    }
    .add-melody-new-corner-mark {
      height: 32px;
      width: 32px;
      position: absolute;
      top: 0;
      right: 0;
      background: url("@/assets/img/new-corner-mark.png");
      background-size: 100% 100%;
      border-radius: 0 12px 0 0;
      overflow: hidden;
      span {
        position: absolute;
        font-family: HarmonyOS Sans SC;
        height: 20px;
        width: 44px;
        font-size: 9px;
        font-weight: 500;
        line-height: 24px;
        text-align: center;
        color: #4c2a87;
        transform: rotate(45deg);
      }
    }
  }
  .add-music-reference-edit-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .add-melody-record-desc {
    font-family: HarmonyOS Sans SC;
    font-size: 11px;
    font-weight: 500;
    line-height: normal;
    text-align: center;
    color: rgba(255, 255, 255, 0.5);
    margin: 8px auto 0 auto;
    max-width: 250px;
  }
  .add-melody-record {
    display: flex;
    justify-content: center;
    align-items: center;
    i {
      height: 20px;
      width: 20px;
      min-width: 20px;
      background: url("@/assets/img/record-white-ico.png") no-repeat center;
      background-size: 100% 100%;
    }
    span {
      margin-left: 4px;
      font-family: HarmonyOS Sans SC;
      font-size: 14px;
      font-weight: normal;
      color: #ffffff;
    }
    label.vip_plan {
      min-width: max-content;
      height: 14px;
      border-radius: 2px;
      background: linear-gradient(
        110deg,
        #ffe08b 0%,
        #fff7d0 47%,
        #ffe08b 100%
      );
      padding: 0 3px;
      line-height: 14px;
      font-family: Source Han Sans;
      font-size: 8px;
      font-weight: 500;
      color: #3d2d00;
      margin: 0 0 0 8px;
    }
  }

  &.add-melody-record-container--mobile {
    .add-melody-record-main {
      padding: 0 0px;
      height: 70px;
      span {
        font-size: 16px;
      }
      i {
        height: 16px;
        width: 16px;
        min-width: 16px;
      }
      .vip_plan {
        margin: 0 0 0 4px;
      }
      .add-melody-record-desc {
        margin: 8px auto 0 auto;
        padding: 0 8px;
        font-size: 11px;
        max-width: 100%;
        min-height: unset;
      }
    }
  }
  &.add-melody-record-container--cn {
    .add-melody-record-main {
      height: 56px;
    }
    .add-melody-record-desc {
      display: none;
    }
    &.add-melody-record-container--mobile {
      .add-melody-record-main {
        height: 56px;
      }
    }
  }
}
</style>
